import React, { Component } from 'react';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';

import NewUser from '../components/Profile/New';
import EditUser from '../components/Profile/EditUser';

import api from '../api/backend'

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    addCourse: {
        marginBottom: 20
    },
    icon: {
        marginRight: theme.spacing.unit * 2,
    },
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class UserManager extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            users: [],
            page: 1,
            pageSize: 20,
            total: 0,
            term: '',
            loading: false,
        }
    }

    componentDidMount() {
        this.fetchUsers()
    }

    fetchUsers = () => {
        const { page, pageSize, term } = this.state
        this.setState({ loading: true })
        api.getUsersPaged(page, pageSize, term, true).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({
                    users: json.items || [],
                    total: json.total || 0,
                    page: json.page || 1,
                    pageSize: json.pageSize || pageSize,
                })
            } else {
                console.error('ไม่สามารถรับค่าจากผู้ใช้ทั้งหมดได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    onUserCreated = () => {
        this.setState({ page: 1 }, this.fetchUsers)
    }

    onUserUpdated = () => {
        this.fetchUsers()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage + 1 }, this.fetchUsers)
    }

    handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10)
        this.setState({ pageSize: newSize, page: 1 }, this.fetchUsers)
    }

    handleSearch = () => {
        this.setState({ page: 1 }, this.fetchUsers)
    }

    render() {
        const { classes } = this.props;
        const { users, page, pageSize, total, loading } = this.state;
        return (
            <main>
                {/* Hero unit */}
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            ผู้ใช้งานทั้งหมด
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.handleSearch()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <NewUser onCreated={this.onUserCreated} />
                        </Grid>
                    </Grid>

                    {loading && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
                            <CircularProgress size={80} thickness={4} />
                            <Typography variant="title" color="textSecondary" style={{ marginTop: 24 }}>
                                กำลังโหลด...
                            </Typography>
                        </div>
                    )}
                    <Paper className={classes.root} style={{ display: loading ? 'none' : 'block' }}>
                        <Table className={classes.table} padding="dense">
                            <TableHead>
                                <TableRow>
                                    <TableCell>ชื่อนามสกุล</TableCell>
                                    <TableCell numeric>ชื่อเล่น</TableCell>
                                    <TableCell numeric>สถานะ</TableCell>
                                    <TableCell numeric>สถานะการใช้งาน</TableCell>
                                    <TableCell numeric></TableCell>
                                    <TableCell numeric></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.map(row => {
                                    return (
                                        <EditUser key={row.id} user={row} onUpdated={this.onUserUpdated} />
                                    );
                                })}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={total}
                            rowsPerPage={pageSize}
                            page={page - 1}
                            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 20, 50, 100]}
                            labelRowsPerPage="แสดงต่อหน้า:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} จาก ${count}`}
                        />
                    </Paper>
                </div>
            </main>
        );
    }
}

export default withStyles(styles)(UserManager);
